import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export const store = new Vuex.Store({

  state: {    
    socket: {},
  },

  mutations: {
    set_socket(state, valor){
      state.socket = valor
    }
  },

  actions:{},

  getters:{
    //pessoa: state => state.pessoa
  },

});





// WEBPACK FOOTER //
// ./src/store/store.js